import { TextField,Typography } from "@mui/material";
import { useMask } from "@react-input/mask";
import { useContext,useEffect,useState } from "react";
import { useTranslation } from "react-i18next";
import { WebFormContext } from "../../../../context/WebFormContext";
import { trackEventMatomo } from "../../../../helpers/matomo";
import CepService from "../../../../service/CepService";
import { SubItemFormFilling } from "../../../../types/new-form-filling/types";
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from "../../Structure/AdditionalInfo";

type Props = {
  value: string | string[] | null;
  setValue: Function;
  subitem: SubItemFormFilling,
};

const CepComp = ({ subitem, value, setValue }: Props) => {
  const { ForceUpdate } = useContext(WebFormContext);
  const cepRef = useMask({ mask: '_____-___', replacement: { _: /\d/ } });
  const cepService = new CepService();
  const [isValidCep, setIsValidCep] = useState<boolean | null>(null);
  const { t } = useTranslation('translation');


  useEffect(() => {
    const verificarCep = async () => {
      if (value?.length === 9) {
        const isValid = await cepService.ValidaCep(value as string);
        setIsValidCep(isValid);
      } else {
        setIsValidCep(null);
      }
    };
    verificarCep();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (subitem.ocorrencia) {
      setValue(subitem.ocorrencia);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subitem.ocorrencia) return;
    if (subitem.padrao) {
      setValue(subitem.padrao);
      subitem.ocorrencia = subitem.padrao as string;
    }
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true;
    } else if (!value) {
      delete subitem.checked;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {CheckIcon(subitem, value) === 'naoOk' && '*'}  {(subitem.id + 1)}
        - {subitem.nome}
      </Typography>
      <TextField
        error={isValidCep === false}
        inputRef={cepRef}
        helperText={isValidCep === false ? t('cepInvalid') : null}
        style={{ backgroundColor: 'inherit' }}
        onClick={() => trackEventMatomo('seleciona documento', 'click', 'input', 'edita valor')}
        value={(value ?? '') as string}
        className={`${subitem.itemid}|${subitem.id}`}
        type="text"
        variant='outlined'
        onChange={(event) => {
          setValue(event.target.value);
          subitem.ocorrencia = event.target.value;
          if (!event.target.value?.length) {
            delete subitem.ocorrencia;
          }
        }}
      />
      {value?.length === 9 && <AdditionalInfo subItem={subitem} />}
    </>
  );
};

export default CepComp;